import { observer } from "mobx-react";
import React, { useEffect, useState} from "react";
import { profileStore } from "../stores/ProfileStore";
import { LoadingCard } from "../components/LoadingCard";
import { EmptyState } from "../components/EmptyState";
import { t } from "../utils";
import { IIcon } from "../SVG";
import SearchCard from "../Search/SearchCard";

interface IProps {
	isPupil: boolean;
}


const UserFavApaArticles: React.FunctionComponent<IProps> = observer((props) => {
	const [isLoading, setIsLoading] = useState(true);
	const init = async () => {
		await Promise.all([
			profileStore.loadFavApaArticles(),
		]);
		setIsLoading(false);
	};

	useEffect(() => {
		setIsLoading(true);
		void init();
	}, []);

	return (
		<>
			{isLoading ? (
				<div>
					<LoadingCard style={{ marginTop: "1.5rem" }} className="mobile-portrait-mode" />
				</div>
			) : (
				<>
					{profileStore.apaFavs.length > 0 ? (
						profileStore.apaFavs.map((wishlistItem, index) => (
						<SearchCard
							id={wishlistItem.id}
							key={index}
							image={wishlistItem?.data?.imageUrl}
							text={wishlistItem?.data?.description}
							title={wishlistItem?.data?.title}
							chips={wishlistItem?.data?.chips}
							eventCategories={wishlistItem?.data?.eventCategories}
							url={wishlistItem?.data?.url}
							isOnWishlist={wishlistItem.data?.isOnWishlist}
							productCategory={wishlistItem?.data?.fileExtension}
							icon={
								wishlistItem?.data?.fileExtensionIconType as IIcon
							}
							fallbackImage={wishlistItem?.data?.fallbackImageType}
							downloadUrl={wishlistItem?.data?.downloadUrl}
							purchasableId={wishlistItem?.data?.purchasableId}
							canAddToCart={wishlistItem?.data?.canAddToCart}
							isApp={wishlistItem?.data?.isApp}
							isDigitalProduct={wishlistItem?.data?.isDigitalProduct}
							startDate={wishlistItem.data?.startDate}
							endDate={wishlistItem.data?.expiryDate}
							onlineLocation={wishlistItem.data?.onlineLocation}
							isEvent={Array.isArray(wishlistItem?.data?.eventCategories)}
							trackingData={wishlistItem?.data?.trackingData}
							isNew={wishlistItem?.data?.isNew}
							elementType="apaArticleUserMenu"
							subTitle={wishlistItem.data?.subTitle}
							subtitle={wishlistItem.data?.subtitle}
							relatedProducts={wishlistItem.data?.relatedProducts}
						/>
						))
					) : (
						<EmptyState
							headline={t("my_oebv.apa.empty.headline")}
							text={t("my_oebv.apa.empty.text")}
							link={"/science-ticker"}
							linkText={t("my_oebv.apa.empty.button")}
							imageType="woman" />
					)}
				</>
			)}
		</>
	);
});
export default UserFavApaArticles;

//export class UserFavApaArticles {}